import { useEffect, useRef } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { Button } from '@iwoca/orion';
import { useNavigate } from 'react-router';

import redQuarterSVG from './redQuarterCircle.svg';
import { useSuspenseGetSharedFunctionality } from '../../../../api/lending/lapiHooks.suspense';
import { buildQueryString } from '../../../utils/queryParams';
import { useSuspenseGetANTFormalOffers } from '../../hooks/useGetANTFormalOffers';

export const BuyerCrossSellCard = () => {
  const { antFormalOffers } = useSuspenseGetANTFormalOffers();
  const navigate = useNavigate();
  const { functionality } = useSuspenseGetSharedFunctionality({
    functionalities: [
      'is_cross_sell_eligible',
      'should_use_new_flexi_loan_form',
    ],
  });
  const hasTrackedView = useRef(false);

  const isVisible =
    functionality?.is_cross_sell_eligible &&
    !(antFormalOffers && antFormalOffers.length > 0);

  useEffect(() => {
    if (!isVisible) return;
    if (hasTrackedView.current) return;
    hasTrackedView.current = true;
    tracking.ampli.buyerDisplayedXSellBanner();
  }, [isVisible]);

  if (!isVisible) return null;

  const shouldUseNewForm = !!functionality?.should_use_new_flexi_loan_form;

  const handleClick = () => {
    tracking.ampli.buyerClickedXSellBanner();

    if (shouldUseNewForm) {
      navigate('/pay/apply-flexi-loan/');
    } else {
      window.location.href = `/account/apply-flexi-loan/${buildQueryString({ ipxsell: '1' })}`;
    }
  };

  return (
    <div className="relative z-0 mb-xl overflow-hidden rounded-l bg-primary-20 p-l">
      <img
        src={redQuarterSVG}
        alt=""
        className="pointer-events-none absolute right-0 top-0 z-0 select-none"
      />
      <div className="flex w-full items-center justify-between gap-s text-structure-100 sm:flex-col sm:gap-l">
        <div>
          <h2 className="m-0 mb-xs text-xl font-bold">
            Get a business loan with iwoca
          </h2>
          <p className="m-0 text-s font-reg">
            Borrow &pound;1,000 &ndash; &pound;1,000,000 to buy new stock,
            invest in growth plans or just keep your cash flow smooth.
          </p>
        </div>
        <div className="flex flex-col items-center gap-s sm:w-full">
          <Button
            variant="secondary"
            onClick={handleClick}
            id="applyForFlexi_INCLUDE"
            className="z-10 w-full"
          >
            Apply now
          </Button>
          <p className="m-0 p-0 text-center text-xs font-med text-structure-100">
            Applying won't affect your credit score
          </p>
        </div>
      </div>
    </div>
  );
};
